import React from 'react';
import { CategoryProvider } from 'providers';
import Categories from './Page';

export default function Page() {
  return (
    <CategoryProvider>
      <Categories />
    </CategoryProvider>
  );
}
